var _g, _rect, _rect2, _rect3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgInvoiceFilled = function SvgInvoiceFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 127,
    viewBox: "0 0 119 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#svg-public/img/icons/documents/invoice_filled.svg__filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.9268 20C42.7176 20 40.9268 21.7909 40.9268 24V65.6472C40.9268 66.3197 41.5771 66.8005 42.22 66.6033L50.8332 63.9611C51.0334 63.8997 51.2478 63.9027 51.4462 63.9696L60.0791 66.8827C60.3036 66.9584 60.5476 66.952 60.7678 66.8646L67.9862 63.999C68.2018 63.9135 68.4403 63.9055 68.6611 63.9764L76.7637 66.5803C77.4092 66.7878 78.0696 66.3063 78.0696 65.6283V24C78.0696 21.7909 76.2787 20 74.0696 20H44.9268Z",
    fill: "#005FF9"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 47.9531,
    y: 35,
    width: 21.0811,
    height: 2,
    rx: 1,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 47.9531,
    y: 40,
    width: 18.0695,
    height: 2,
    rx: 1,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 47.9531,
    y: 45,
    width: 12.0463,
    height: 2,
    rx: 1,
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "svg-public/img/icons/documents/invoice_filled.svg__filter0_d",
    x: 0.926758,
    y: 0,
    width: 117.143,
    height: 126.935,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.227451 0 0 0 0 0.596078 0 0 0 0.28 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
};
export { SvgInvoiceFilled as ReactComponent };